import { Stack } from "@mui/material";
import { HIDDEN_PASSWORD_TEXT } from "@src/appV2/redesign/Charting/constants";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useState } from "react";

interface PasswordDisplayProps {
  password: string;
  isInitiallyVisible?: boolean;
}

export function PasswordDisplay({ password, isInitiallyVisible = false }: PasswordDisplayProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(isInitiallyVisible);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible((previous) => !previous);
  };

  return (
    <Stack direction="row" gap={2} alignItems="center">
      <Text onClick={togglePasswordVisibility}>
        {isPasswordVisible ? password : HIDDEN_PASSWORD_TEXT}
      </Text>
      <IconButton
        data-testid="toggle-password-visibility"
        size="xSmall"
        variant="outlined"
        iconType={isPasswordVisible ? "eye" : "eye-slash"}
        onClick={togglePasswordVisibility}
      />
    </Stack>
  );
}
